<template>
  <v-card>
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>{{ this.title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex md10>
            <v-layout row wrap>
              <v-flex md2>
                <v-text-field
                  v-model="enumItem.id"
                  :label="$t('administration.parametreenum.form.id')"
                  disabled
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  v-model="enumItem.code"
                  :label="$t('administration.parametreenum.form.code')"
                  :readonly="
                    (this.modeModification && !this.codeUpdatable) || !editable
                  "
                />
              </v-flex>
              <v-flex md6>
                <v-text-field
                  v-model="enumItem.libelleCourt"
                  :label="$t('administration.parametreenum.form.libelleCourt')"
                  :readonly="!editable"
                />
              </v-flex>
              <v-flex md12>
                <v-text-field
                  v-model="enumItem.libelle"
                  :label="$t('administration.parametreenum.form.libelle')"
                  :readonly="!editable"
                />
              </v-flex>
              <v-flex
                v-for="extraField in this.extraFields"
                :key="extraField.name"
                md12
              >
                <v-text-field
                  v-if="
                    extraField.type === 'text' || extraField.type === 'integer'
                  "
                  v-model="enumItem[extraField.name]"
                  :label="
                    $t(
                      'administration.parametreenum.form.' +
                        (enumType !== null ? enumType + '.' : '') +
                        extraField.name,
                    )
                  "
                  :readonly="!editable"
                />
                <v-checkbox
                  v-else-if="extraField.type === 'boolean'"
                  v-model="enumItem[extraField.name]"
                  :label="
                    $t(
                      'administration.parametreenum.form.' +
                        (enumType !== null ? enumType + '.' : '') +
                        extraField.name,
                    )
                  "
                  :readonly="!editable"
                  color="primary"
                />
                <enum-entity-field
                  v-else-if="extraField.type === 'enum'"
                  :namespace="'abstractenum/' + extraField.enumNamespace"
                  v-model="enumItem[extraField.name]"
                  :i18n="
                    $t(
                      'administration.parametreenum.form.' +
                        (enumType !== null ? enumType + '.' : '') +
                        extraField.name,
                    )
                  "
                  :readonly="!editable"
                />
                <enum-entity-field
                  v-else-if="extraField.type === 'staticEnum'"
                  :namespace="'enum/' + extraField.enumNamespace"
                  v-model="enumItem[extraField.name + 'Object'].value"
                  :i18n="
                    $t(
                      'administration.parametreenum.form.' +
                        (enumType !== null ? enumType + '.' : '') +
                        extraField.name,
                    )
                  "
                  :readonly="!editable"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md2>
            <v-switch
              v-model="enumItem.actif"
              :label="getEnumStatus(enumItem.actif)"
              color="primary"
            ></v-switch>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn @click="abortEdition">
        {{ $t('administration.parametreenum.buttons.cancel') }}
      </v-btn>
      <v-btn color="primary" @click="confirmEdition">
        {{ $t('administration.parametreenum.buttons.confirm') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const NAMESPACE = 'parametres';
import { maxLength, required } from 'vuelidate/lib/validators';

export default {
  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    };
  },
  model: {
    prop: 'item',
    event: 'input',
  },
  props: {
    enumType: null,
    item: {},
    title: {
      type: String,
    },
    modeModification: {
      type: Boolean,
      default: false,
    },
    modeCreation: {
      type: Boolean,
      default: false,
    },
    codeUpdatable: {
      type: Boolean,
      default: false,
    },
    extraFields: {},
  },
  computed: {
    editable() {
      return this.modeCreation || this.modeModification;
    },
  },
  watch: {
    item(val) {
      Object.assign(this.enumItem, val);
    },
  },
  data() {
    return {
      enumItem: this.item,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    getEnumStatus(value) {
      return this.$i18n.t(
        'administration.parametreenum.table.fields.actif.' + value,
      );
    },
    abortEdition() {
      this.$v.$reset();
      this.$emit('abort');
    },
    confirmEdition() {
      this.$v.$touch();
      this.$emit('confirm', !this.$v.$invalid);
    },
  },
  validations() {
    const validations = {
      enumItem: {
        code: {
          required,
          maxLength: maxLength(255),
        },
        libelle: {
          required,
          maxLength: maxLength(255),
        },
        libelleCourt: {
          maxLength: maxLength(255),
        },
        actif: {
          required,
        },
      },
    };
    validations[this.extrafield] = {};
    return validations;
  },
};
</script>
